import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { DateTime } from "components/common/Date";
import { useUserOverview } from "./UserOverviewContext";

const OverviewTab = () => {
  const { user } = useUserOverview();

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <CardBody>
              <div className="text-muted">
                <h6 className="mb-3 text-uppercase">Info</h6>
                <Row>
                  <Col lg={8}>
                    <div className="table-responsive">
                      <Table className="table-borderless mb-0">
                        <tbody>
                          <tr>
                            <th className="ps-0" scope="row">
                              First Name :
                            </th>
                            <td className="text-muted">{user?.firstName}</td>
                          </tr>

                          <tr>
                            <th className="ps-0" scope="row">
                              Last Name :
                            </th>
                            <td className="text-muted">{user?.lastName}</td>
                          </tr>

                          <tr>
                            <th className="ps-0" scope="row">
                              E-mail :
                            </th>
                            <td className="text-muted">{user?.email}</td>
                          </tr>

                          <tr>
                            <th className="ps-0" scope="row">
                              Phone :
                            </th>
                            <td className="text-muted">{user?.phone || "—"}</td>
                          </tr>

                          <tr>
                            <th className="ps-0" scope="row">
                              Roles :
                            </th>
                            <td>
                              {user?.roles?.length ? (
                                <div className="d-flex flex-wrap gap-2 fs-16">
                                  {user?.roles?.map((r) => (
                                    <div
                                      key={r.id}
                                      className={`badge fw-medium bg-${"primary"}-subtle text-${"primary"}`}
                                    >
                                      {r.name}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>
                          </tr>

                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>

                <div className="pt-3 border-top border-top-dashed mt-4">
                  <Row className="gy-3">
                    {user?.created_at ? (
                      <Col lg={3} sm={6}>
                        <div>
                          <p className="mb-2 text-uppercase fw-medium">
                            Created
                          </p>
                          <h5 className="fs-14 mb-0">
                            <DateTime date={user.created_at} />
                          </h5>
                        </div>
                      </Col>
                    ) : null}
                    {user?.updated_at ? (
                      <Col lg={3} sm={6}>
                        <div>
                          <p className="mb-2 text-uppercase fw-medium">
                            Last updated
                          </p>
                          <h5 className="fs-14 mb-0">
                            <DateTime date={user.updated_at} />
                          </h5>
                        </div>
                      </Col>
                    ) : null}
                    {user?.lastSeenAt ? (
                      <Col lg={3} sm={6}>
                        <div>
                          <p className="mb-2 text-uppercase fw-medium">
                            Last seen
                          </p>
                          <h5 className="fs-14 mb-0">
                            <DateTime date={user.lastSeenAt} />
                          </h5>
                        </div>
                      </Col>
                    ) : null}
                  </Row>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default OverviewTab;
